import { render, staticRenderFns } from "./cloaking.vue?vue&type=template&id=9ed4bd1c&scoped=true&"
import script from "./cloaking.vue?vue&type=script&lang=ts&"
export * from "./cloaking.vue?vue&type=script&lang=ts&"
import style0 from "./cloaking.vue?vue&type=style&index=0&id=9ed4bd1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed4bd1c",
  null
  
)

export default component.exports